module.exports = __webpack_public_path__ + "img/cash.00f3959f.png";